import { NEEDS_COMPANY, NEEDS_USDOT, NEEDS_FLEET_SIZE, NEEDS_OPERATING_AREA, COMPANY_LABEL } from "@/components/preregister/preRegisterConstants";

export const PreRegisterFormFields = ({ segment, form, update }) => (
  <>
    {NEEDS_COMPANY.includes(segment) && (
      <input data-testid="preregister-company-input" placeholder={COMPANY_LABEL[segment]} value={form.company} onChange={update("company")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    )}
    {NEEDS_USDOT.includes(segment) && (
      <input data-testid="preregister-usdot-input" placeholder="USDOT number (if applicable)" value={form.usdot} onChange={update("usdot")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    )}
    {NEEDS_FLEET_SIZE.includes(segment) && (
      <input type="number" min="0" data-testid="preregister-fleet-size-input" placeholder="Fleet size" value={form.fleetSize} onChange={update("fleetSize")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    )}
    {NEEDS_OPERATING_AREA.includes(segment) && (
      <input data-testid="preregister-operating-area-input" placeholder="Operating area / expected driver needs" value={form.operatingArea} onChange={update("operatingArea")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    )}
  </>
);
